// Figma: 6086:28468 — see stories/blocks/trusted-customers-logo-cells.stories.tsx
"use client";

import { Link } from "@/components/ui/link";
import { cn } from "@/lib/utils";

import { CustomersGridAnimatedLogo } from "./customers-grid-animated-logo";
import type { CustomerLogoId, LogoSlotConfig } from "./customers-grid-catalog";
import { getCustomerLogoEntry } from "./customers-grid-catalog";
import {
  customersGridColumnFromIndex,
  customersGridLastRowStackZIndex,
  customersGridRowBorderClass,
  customersGridRowFromIndex,
} from "./customers-grid-layout";
import { useCustomersGridLogoRotation } from "./use-customers-grid-logo-rotation";

interface TrustedCustomersLogoCellsProps {
  slots: LogoSlotConfig[];
  poolIds: CustomerLogoId[];
  animate: boolean;
  paused?: boolean;
  variant: "compact" | "desktop";
  columns: number;
  totalRows: number;
  /** Grid index of the first slot (1 when an intro cell occupies index 0). */
  gridIndexOffset?: number;
  cardClassName: string;
  cellClassName: string;
}

export function TrustedCustomersLogoCells({
  slots,
  poolIds,
  animate,
  paused = false,
  variant,
  columns,
  totalRows,
  gridIndexOffset = 0,
  cardClassName,
  cellClassName,
}: TrustedCustomersLogoCellsProps) {
  const displaySlots = useCustomersGridLogoRotation(
    slots,
    poolIds,
    animate,
    paused
  );
  const mediaSizeKey =
    variant === "desktop" ? "desktopMediaSize" : "compactMediaSize";

  return (
    <>
      {displaySlots.map((slot, index) => {
        const entry = getCustomerLogoEntry(slot.id);
        const mediaSizeClass = entry[mediaSizeKey];
        const row = customersGridRowFromIndex(index + gridIndexOffset, columns);
        const column = customersGridColumnFromIndex(
          index + gridIndexOffset,
          columns
        );
        const lastRowStackZ = customersGridLastRowStackZIndex(
          row,
          column,
          totalRows,
          columns
        );

        return (
          <li
            key={index}
            className={cn(
              cardClassName,
              customersGridRowBorderClass(row, totalRows),
              mediaSizeClass,
              cellClassName,
              slot.plusBg && "relative",
              lastRowStackZ !== undefined && "relative"
            )}
            style={
              lastRowStackZ !== undefined
                ? { zIndex: lastRowStackZ }
                : undefined
            }
          >
            <Link
              href={entry.href}
              className="text-grey-950 relative flex h-full w-full items-center justify-center transition-opacity hover:opacity-70"
              data-ph-capture-attribute-cta_label={`Trusted Customers Grid - ${slot.id}`}
              data-ph-capture-attribute-cta_url={entry.href}
            >
              <CustomersGridAnimatedLogo logoId={slot.id} variant={variant} />
            </Link>
          </li>
        );
      })}
    </>
  );
}
